module.exports = "<div class=row> <div class=col-lg-12> <div class=\"wrapper wrapper-content\"> <div class=ibox> <div class=ibox-content> <div class=\"ibox-content action-container\"> <action-list contents=\"{\n                        title: 'Do you intend to use Clerk ...',\n                    }\"> <personal-service-usage-intentions-action-list-item></personal-service-usage-intentions-action-list-item> </action-list> </div> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/1-owner/preferences.html
// module id = 628
// module chunks = 86